'use strict';

module.exports = angular.module('ui.utils.masks', [
	require('./global/global-masks')
]).name;
